import { ClarionTag as Tag, type ClarionTagProps as TagProps } from '@clarion/ClarionTag';
import { FileLabel as FileLabelType } from './assignment';

type FileLabelProps = TagProps & {
  label: FileLabelType;
};

export default function FileLabel({ label }: FileLabelProps) {
  return (
    <Tag style={{ backgroundColor: label.color, color: getContrastColor(label.color) }}>
      {label.name}
    </Tag>
  );
}

/**
 * Determines whether to use white or black text based on background color
 * for optimal contrast
 */
function getContrastColor(hexColor: string): string {
  // Remove the hash if it exists
  const color = hexColor.replace('#', '');

  // Convert to RGB
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  // Calculate luminance - using the formula for relative luminance in the sRGB color space
  // See: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return black for bright colors, white for dark colors
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}
